import {Schema} from '@zaiusinc/app-forms-schema';
import {DataStore} from '../stores/DataStore';
import {PredicateEvaluator} from './PredicateEvaluator';

export interface Attributes {
  readonly: boolean;
  disabled: boolean;
  visible: boolean;
}

export function evaluateAttributes(section: string, schema: Schema.AnyElement, data: DataStore): Attributes {
  const evaluator = new PredicateEvaluator(section, data);
  return {
    readonly: evaluator.evaluate(schema.readonly, false),
    disabled: evaluator.evaluate(schema.disabled, false),
    visible: evaluator.evaluate(schema.visible, true)
  };
}
